import { createApp, Vue } from "vue";
import App from "./App.vue";
import ElementPlus from "element-plus";
// import 'element-plus/dist/index.css'
// import 'element-plus/theme-chalk/index.css'
import { ElMessage } from "element-plus";
import "element-plus/lib/theme-chalk/index.css";
import * as echarts from "echarts";
import i18n from "./language/index";
import axios from "axios";
import router from "./router";
import store from "./store";
import Print from "vue3-print-nb";
import "lib-flexible";
import "./assets/css/base.css";
import * as dd from "dingtalk-jsapi";
import "./assets/css/elementplus.scss";

const app = createApp(App);
app.use(store);
app.use(router);
app.use(i18n);
app.use(Print);
app.use(ElementPlus);
app.use(ElementPlus, {
  VueI18n: i18n.global.t,
});

// app.config.globalProperties.$t = i18n.global.t;
// app.config.globalProperties.$i18n = i18n.global;
console.log(
  "🌐 i18n 实例:",
  i18n.global.locale.value,
  i18n.global.messages.value
);
console.log("🔧 App 配置:", app.config.globalProperties);

app.config.globalProperties.$echarts = echarts;
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$dd = dd;
app.config.globalProperties.$ElMessage = ElMessage;
app.config.globalProperties.$api = process.env.VUE_APP_API_PREFIX;

axios.defaults.headers = {
  "Content-Type": "application/json;charset=UTF-8",
};

app.mount("#app");
